<div style="min-height: 70vh;" class="pt-3 pb-5 container">
    <button mat-button (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        Back
    </button>

    <!-- Title -->
    <div class="text-center mt-5 mb-0">
        <mat-icon class="h-100 w-100" style="font-size: xx-large;">restart_alt</mat-icon>
        <h1>Lost password</h1>
    </div>

    <mat-divider class="mx-auto" [ngClass]="{'w-75' : isHandset$, 'w-50' : !isHandset$}">
    </mat-divider>

    <!-- Email form-->
    <form *ngIf="isSendingEmailStep && !linkUuid" [formGroup]="emailForm" (ngSubmit)="submitEmailForm()">
        <div class="row pt-5">
            <div class="col-lg-6 mx-auto">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input formControlName="email" matInput type="email" autocomplete="on" required>
                    <mat-hint>Enter email to reset password</mat-hint>
                    <mat-error *ngIf="getEmailForm()['email'].hasError('required')">Field can't be empty
                    </mat-error>
                    <mat-error *ngIf="getEmailForm()['email'].hasError('email')">Please enter valid email
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-5">
            <div class="col-12 text-center">
                <button mat-raised-button [disabled]="isLoading" color="primary" type="submit" class="btn-success"
                    [class.w-25]="!isHandset$" [class.w-50]="isHandset$">
                    <span *ngIf="!isLoading">Submit</span>
                    <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="5" class="mx-auto">
                    </mat-spinner>
                </button>
            </div>
        </div>
    </form>

    <!-- Email sent completion -->
    <div class="row pt-4" *ngIf="shouldRenderEmailSentCompletion">
        <!-- Message -->
        <div class="col-12">
            <h1 class="mb-0">Email confirmation.</h1>
            <p class="text-muted pt-3">You will receive an email to reset your password shortly.</p>
        </div>
    </div>

    <!-- Password reset form -->
    <form class="row pt-3" [formGroup]="passwordFormGroup" (ngSubmit)="submitPasswordForm()" *ngIf="linkUuid">
        <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-dark font-weight-bold text-left">Enter your new password</h2>

            <div class="container">
                <div class="row d-flex flex-column align-items-center">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 p-0">
                        <mat-form-field appearance="outline" class="w-100">
                            <input formControlName="password" matInput type="password" autocomplete="off" required>
                            <mat-label>Password</mat-label>
                            <mat-error *ngIf="getPasswordForm()['password'].hasError('required')">Field can't be
                                empty</mat-error>
                            <mat-error *ngIf="getPasswordForm()['password'].hasError('mustMatch')">Passwords must
                                match</mat-error>
                            <mat-error
                                *ngIf="getPasswordForm()['password'].hasError('minlength') || getPasswordForm()['password'].hasError('maxlength')">
                                Must be between 6 and 20 characters</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-12" [ngClass]="{'p-0' : isHandset$,'' : !isHandset$}">
                        <mat-form-field appearance="outline" class="w-100">
                            <input formControlName="confirmPassword" matInput type="password" autocomplete="off"
                                required>
                            <mat-label>Password confirmation</mat-label>
                            <mat-error *ngIf="getPasswordForm()['confirmPassword'].hasError('required')">Field can't
                                be empty</mat-error>
                            <mat-error *ngIf="getPasswordForm()['confirmPassword'].hasError('mustMatch')">Passwords
                                must match</mat-error>
                            <mat-error
                                *ngIf="getPasswordForm()['confirmPassword'].hasError('minlength') || getPasswordForm()['confirmPassword'].hasError('maxlength')">
                                Must be between 6 and 20 characters</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="col-12 pt-3 text-center">
                <button mat-raised-button [disabled]="isLoading" color="primary" type="submit" class="btn-success"
                    [class.w-25]="!isHandset$" [class.w-50]="isHandset$">
                    <span *ngIf="!isLoading">Submit</span>
                    <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="5" class="mx-auto">
                    </mat-spinner>
                </button>
            </div>
        </div>
    </form>
</div>